class Wishlist {
    constructor() {
        const rawCustomerId = globalThis.customerDetails?.id;
        this.customer_id = rawCustomerId && String(rawCustomerId).trim() ? String(rawCustomerId).trim() : null;
        this.shopDomain = 'diamondsbyuk.myshopify.com';
        this.shopHeader = 'diamondrensu-australia.myshopify.com';
        this.cartElement = document.querySelector('cart-form');
        this.renderWishlist();
    }

    getLocalWishlistItems() {
        try {
            const storedWishlist = JSON.parse(localStorage.getItem('wishlist')) || { items: [] };
            return Array.isArray(storedWishlist.items) ? storedWishlist.items : [];
        } catch (_e) {
            return [];
        }
    }

    showEmptyWishlist() {
        document.querySelector('.wishlist-loading')?.classList.add('d-none');
        const grid = document.querySelector('.wishlist-grid');
        if (grid) grid.innerHTML = '';
        document.querySelector('.custom-wishlist-empty')?.classList.remove('d-none');
        window.refreshWishlistCount?.();
    }

    renderLocalWishlist() {
        document.querySelector('.wishlist-loading')?.classList.add('d-none');
        const items = this.getLocalWishlistItems();
        if (items.length) {
            document.querySelector('.custom-wishlist-empty')?.classList.add('d-none');
            this.renderwishlistgrid(items, null);
        } else {
            this.showEmptyWishlist();
        }
        window.refreshWishlistCount?.();
    }

    async parseJsonResponse(response) {
        const contentType = response.headers.get('content-type') || '';
        const textData = await response.text();

        if (!response.ok) {
            throw new Error(`Wishlist API HTTP ${response.status}`);
        }

        if (!contentType.includes('application/json') || textData.trim().startsWith('<')) {
            throw new Error('Wishlist API returned non-JSON response');
        }

        return JSON.parse(textData);
    }

    async renderWishlist() {
        if (this.customer_id) {
            const storedWishlist = this.getLocalWishlistItems();
            if (storedWishlist.length) {
                const items = storedWishlist.map(item => ({
                    customer_id: parseInt(this.customer_id, 10),
                    variant_id: item.variant_id,
                    product_id: item.product_id,
                    line_item_properties: item.line_item_properties || {},
                    shop: this.shopDomain,
                    product_title: item.product_title,
                    handle: item.handle,
                    item_qty: item.item_qty,
                    image: item.image,
                    video: item.video,
                    image2: item.image_2,
                    type: item.type,
                    product_price: item.product_price,
                    product_compare_price: item.product_compare_price,
                    is_save_later: item.is_save_later
                }));
                await this.addToWishlist(items);
            }

            const endpoint = `https://certificate-manager.diamondrensu.com/api/wishlist?customer_id=${this.customer_id}`;
            try {
                const response = await fetch(endpoint, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-Shop': this.shopHeader,
                    }
                });

                const parsedData = await this.parseJsonResponse(response);
                this.data = parsedData?.data?.data;
                this.paginationData = parsedData?.data?.links;

                if (Array.isArray(this.data) && this.data.length) {
                    this.renderwishlistgrid(this.data, this.paginationData);
                    window.refreshWishlistCount?.();
                } else {
                    this.renderLocalWishlist();
                }
            } catch (error) {
                console.error('Wishlist API error, falling back to local wishlist:', error);
                this.renderLocalWishlist();
            }
        } else {
            // Guest wishlist: render from localStorage (same as cart persistence)
            this.renderLocalWishlist();
        }
    }

    async addToWishlist(items) {
        const endpoint = "https://certificate-manager.diamondrensu.com/api/wishlist/addbulkwishlist";

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Shop': this.shopHeader,
                },
                body: JSON.stringify({ items })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const contentType = response.headers.get('content-type') || '';
            if (!contentType.includes('application/json')) {
                throw new Error('Wishlist bulk add returned non-JSON response');
            }

            await response.json();

            const storedWishlist = JSON.parse(localStorage.getItem('wishlist')) || { items: [] };
            const remainingItems = storedWishlist.items.filter(item =>
                !items.some(addedItem => String(addedItem.variant_id) === String(item.variant_id))
            );
            localStorage.setItem('wishlist', JSON.stringify({ items: remainingItems }));

        } catch (error) {
            console.error('Error:', error);
        }
    }

    renderwishlistgrid(items, paginationData) {
        this.gridHTML = ``;
        this.paginationHTML = ``;
        const paginationContainer = document.querySelector('.pagination-container');

        // Clear previous pagination
        if (paginationContainer) paginationContainer.innerHTML = '';

        // Show "Previous" button only if more than 4 links
        if (paginationData != null && paginationContainer) {
        if (paginationData.length > 4) {
            const prevPage = paginationData.find(page => page.label === "&laquo; Previous");
            if (prevPage) {
                const prevElement = document.createElement('li');
                prevElement.classList.add('page-item');
                const prevLink = document.createElement('a');
                prevLink.classList.add('page-link');
                prevLink.href = prevPage.url || '#';
                prevLink.innerHTML = "&laquo; Previous";
                prevLink.addEventListener('click', (event) => {
                    event.preventDefault();
                    if (prevPage.url) {
                        this.fetchWishlistData(`${prevPage.url}&customer_id=${this.customer_id}`);
                    }
                });
                prevElement.appendChild(prevLink);
                paginationContainer.appendChild(prevElement);
            }
        }

        // Render pagination links
        paginationData
            .filter(page => page.label !== "&laquo; Previous" && page.label !== "Next &raquo;") // Exclude "Next" and "Previous" here
            .forEach(page => {
                const pageElement = document.createElement('li');
                pageElement.classList.add('page-item');

                if (page.active) {
                    pageElement.classList.add('active');
                }

                const pageLink = document.createElement('a');
                pageLink.classList.add('page-link');
                pageLink.href = page.url || '#';
                pageLink.innerHTML = page.label;

                pageLink.addEventListener('click', (event) => {
                    event.preventDefault();
                    if (page.url) {
                        this.fetchWishlistData(`${page.url}&customer_id=${this.customer_id}`);
                    }
                });

                pageElement.appendChild(pageLink);
                paginationContainer.appendChild(pageElement);
            });

        // Show "Next" button only if more than 4 links
        if (paginationData.length > 4) {
            const nextPage = paginationData.find(page => page.label === "Next &raquo;");
            if (nextPage) {
                const nextElement = document.createElement('li');
                nextElement.classList.add('page-item');
                const nextLink = document.createElement('a');
                nextLink.classList.add('page-link');
                nextLink.href = nextPage.url || '#';
                nextLink.innerHTML = "Next &raquo;";
                nextLink.addEventListener('click', (event) => {
                    event.preventDefault();
                    if (nextPage.url) {
                        this.fetchWishlistData(`${nextPage.url}&customer_id=${this.customer_id}`);
                    }
                });
                nextElement.appendChild(nextLink);
                paginationContainer.appendChild(nextElement);
            }
        }
    }
        if (items != undefined && items.length) {
            document.querySelector('.wishlist-loading')?.classList.add('d-none');
            document.querySelector('.custom-wishlist-empty')?.classList.add('d-none');
            items.forEach(item => {
                let ProertiesDetails = item.line_item_properties;
                let propertiesHTML = '';

                // Clean and format line_item_properties
                const cleanObject = {};
                if (ProertiesDetails != null) {
                    Object.entries(ProertiesDetails).forEach(([key, value]) => {
                        const cleanedKey = key.replace(/^properties\[(.*?)\]$/, '$1');
                        cleanObject[cleanedKey] = value;
                    });
                }

                Object.entries(cleanObject).forEach(([key, value]) => {
                    if ((value !== null && value !== undefined && value !== "")) {
                        propertiesHTML += `
                        <div>
                            <strong>${key}:</strong> ${value}
                        </div>
                    `;
                    }
                });

                // Resolve money format safely from available globals
                const moneyFormat =
                  (window.globalSpace && window.globalSpace.money_format) ||
                  (globalThis.themeData && globalThis.themeData.money_format) ||
                  (window.Shopify && window.Shopify.money_format) ||
                  '${{amount}}';

                // Discount calculation
                var discount_html = ``;
                if (item.product_price && item.product_compare_price) {
                    const compareAtPrice = parseInt(item.product_compare_price);
                    const price = parseInt(item.product_price);

                    const priceDifference = compareAtPrice - price;
                    const discountPercentage = Math.round((priceDifference * 100) / compareAtPrice);
                    if (discountPercentage > 0) {
                        discount_html = `<span class="discount-percentage bg-primary-200 text-primary rounded-pill px-1 fs-xs text-uppercase flex-shrink-0">${discountPercentage}% off</span>`;
                    }
                }
                var comapreAtHTML = ``;
                if (item.product_compare_price != null ) {
                    comapreAtHTML =` <s class="m-0 p-0 discount-price fs-sm fw-normal money text-gray-500" data-compareprice="">${Utility.formatMoney(item.product_compare_price, moneyFormat)}</s> ` ;
                }

                const hasVideo =
                  (typeof item.video === 'string' && item.video.trim().length > 0) ||
                  (typeof item.video !== 'string' && !!item.video);
                const secondImage =
                  (typeof item.image_2 === 'string' && item.image_2.trim().length > 0) ? item.image_2.trim() : '';

                const hoverMediaHtml = hasVideo
                  ? `
                    <div class="position-absolute product-video wishlist-video-container top-0 start-0 bottom-0 w-100">
                      <video src="${item.video}" class="w-100 h-100 object-fit-cover" autoplay muted loop playsinline preload="metadata"></video>
                    </div>
                  `
                  : (secondImage
                      ? `
                        <picture class="position-absolute wishlist-video-container w-100 h-100 top-0 start-0">
                          <img src="${secondImage}" loading="lazy" class="w-100 h-100 object-fit-cover" alt="${item.product_title}" title="${item.product_title}" width="2048" height="2048">
                        </picture>
                      `
                      : ``);
                this.gridHTML += `

                    <div class="card card-product card-product-style-1 text-start rounded-0 border-0 position-relative" data-product-grid="">
                        <div data-remove-from-wishlist data-productid="${item.product_id}" data-var_id="${item.variant_id}" class="removefromwishlist bg-white end-0 p-2 position-absolute rounded-circle d-flex justify-content-center m-2 text-gray-900 bg-gray-100">
                            <svg aria-hidden="true" focusable="false" style="width:10px;height:10px;">
                                <use href="#icon-close"></use>
                            </svg>
                        </div>
                        <div class="card-img text-center position-relative ">
                        <a href="/products/${item.handle}" class="d-block product-link rounded-lg overflow-hidden position-relative w-100 ">
                          <picture class="position-absolute w-100 h-100 top-0 start-0">
                                <img src="${item.image}" loading="lazy" class="w-100" alt="${item.product_title}" title="${item.product_title}" data-hoverimage="" width="2048" height="2048">
                            </picture>
                            ${hoverMediaHtml}
                            </a>
                            </div>

                  <div class="card-body px-0 py-2">
                    <div class="row no-gutter h-100">
                        <div class="col-12">
                          <p class="card-title mb-2 font-family-base">
                            <a class="product-link fw-semibold text-gray-900" role="button" href="/products/${item.handle}">${item.product_title}</a>
                          </p>
                        </div>

                        <a href="/products/${item.handle}" class="col-12 d-flex align-items-center flex-wrap gap-1">
                            <span class="price m-0 p-0 money fw-semibold fs-lg text-gray-900" data-currentprice="">${Utility.formatMoney(item.product_price, moneyFormat)}</span>
                            ${comapreAtHTML}
                            ${discount_html}</a>

                    </div>
                    </div>
                    <div class="col-12 mt-auto">
                    <a class="product-link btn btn-primary-outline w-100 px-2  btn-sm" role="button" href="/products/${item.handle}">Complate Purchase</a>
                        </div>

                </div>
                `;
            });
            document.querySelector(".wishlist-grid").innerHTML = this.gridHTML;
            document.querySelectorAll('[data-remove-from-wishlist]').forEach(button => button.addEventListener('click', this.removeFromwishlist.bind(this)));
            document.querySelectorAll('[data-add-cart]').forEach(button => button.addEventListener('click', this.moveWishlistItemToCart.bind(this)));

            // Some browsers (especially iOS / low power mode) may still block autoplay.
            // Ensure videos are muted + playsInline and retry play when visible.
            const wishlistVideos = document.querySelectorAll('.wishlist-grid video[autoplay]');
            const tryPlay = (video) => {
              if (!video) return;
              video.muted = true;
              video.playsInline = true;
              video.setAttribute('muted', '');
              video.setAttribute('playsinline', '');
              const p = video.play?.();
              if (p && typeof p.catch === 'function') p.catch(() => {});
            };

            if ('IntersectionObserver' in window) {
              const io = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                  const video = entry.target;
                  if (entry.isIntersecting) {
                    tryPlay(video);
                  } else {
                    video.pause?.();
                  }
                });
              }, { threshold: 0.2 });

              wishlistVideos.forEach((video) => {
                tryPlay(video);
                io.observe(video);
              });
            } else {
              wishlistVideos.forEach((video) => tryPlay(video));
            }
        } else {
            document.querySelector('.wishlist-loading')?.classList.add('d-none');
            document.querySelector('.wishlist-grid').innerHTML= ``;
            document.querySelector('.custom-wishlist-empty')?.classList.remove('d-none');
        }
    }

    async fetchWishlistData(url) {
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Shop': this.shopHeader,
                }
            });

            const data = await this.parseJsonResponse(response);
            this.paginationData = data.data.links;
            this.renderwishlistgrid(data.data.data, this.paginationData);
        } catch (error) {
            console.error('Error fetching wishlist:', error);
            this.renderLocalWishlist();
        }
    }

    removeFromwishlist(event){
        let currentTarget = event.currentTarget;
        const productId = currentTarget.dataset.productid;
        const variantId = currentTarget.dataset.var_id;

        if (!this.customer_id) {
            const storedWishlist = JSON.parse(localStorage.getItem('wishlist')) || { items: [] };
            storedWishlist.items = storedWishlist.items.filter(
                (item) => !(String(item.product_id) === String(productId) && String(item.variant_id) === String(variantId))
            );
            localStorage.setItem('wishlist', JSON.stringify(storedWishlist));
            this.renderWishlist();
            window.refreshWishlistCount?.();
            window.notificationEle?.updateNotification('','Item has been successfully removed from your wishlist', {
                type: 'success',
                timeout: 10000
            });
            return;
        }

        const endpoint = "https://certificate-manager.diamondrensu.com/api/wishlist/remove";
        const body = {
            customer_id: this.customer_id,
            product_id: productId,
            variant_id: variantId
        };

        fetch(endpoint, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Shop': this.shopHeader,
            },
            body: JSON.stringify(body)
        })
        .then(async (response) => {
            const contentType = response.headers.get('content-type') || '';
            if (!response.ok || !contentType.includes('application/json')) {
                throw new Error(`Wishlist remove failed (${response.status})`);
            }
            return response.json();
        })
        .then(() => {
            this.renderWishlist();
            window.refreshWishlistCount?.();
            window.notificationEle.updateNotification('','Item has been successfully removed from your wishlist', {
                type: 'success',
                timeout: 8000
              });
        })
        .catch(error => {
            console.error("Error:", error);
        });
    }

    moveWishlistItemToCart(event) {
        let currentTarget = event.currentTarget;
        currentTarget.classList.add('loading');

        // Parse properties from the dataset
        let properties = JSON.parse(currentTarget.dataset.properties);

        delete properties["Metal Type"];

        delete properties["Diamond Size"];

        let body = JSON.stringify({
            id: currentTarget.dataset.variantid,
            quantity: 1,
            properties: properties // Pass properties as an object
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
            .then((response) => response.json())
            .then(() => {
                currentTarget.classList.remove('loading');
                this.cartElement.getCartData('open_drawer');
            })
            .catch((e) => {
                console.error(e);
                Rollbar.error(`Failed to add the product from wishlist page - ${e}`);
            })
            .finally(() => {
                currentTarget.removeAttribute('disabled');
            });
    }

}


typeof Wishlist !== 'undefined' && new Wishlist();
